//-----------------------------------------------------------------------------
//
// menu-structure.js
//
// Copyright 2022 Emergence Software Pte. Ltd. - All rights reserved.
//
//-----------------------------------------------------------------------------


// Definitions
// XXX NEED SUPPLY CHAIN USE CASES!

// Menu structure
export const menuStructure =
[
  { name: "Product",                url: "/product/"               },
  { name: "Pricing",                url: "/pricing/"               },
  { name: "Solutions",              url: "/solutions/",
    children: [
      { name: "General",            url: "/solutions/"     },
      { name: "Executive",          url: "/solutions/#executive"   },
      { name: "Finance",            url: "/solutions/#finance"     },
      { name: "HR",                 url: "/solutions/#hr"          },
      { name: "Marketing",          url: "/solutions/#marketing"   },
      { name: "Medical",            url: "/solutions/#medical"     },
      { name: "Projects",           url: "/solutions/#pm"          },
      { name: "Sales",              url: "/solutions/#sales"       }]
  },
  { name: "Resources",              url: "/resources/",
    children: [
      { name: "Connectors",         url: "/resources/connectors/"  },
      { name: "How-tos",            url: "/resources/how-tos/"     },
      { name: "Integration",        url: "/resources/integration/" },
      { name: "REST APIs",          url: "/resources/rest-api/"    },
      { name: "Examples",           url: "/resources/examples/"    },
      { name: "Guides",             url: "/resources/guides/"      },
      { name: "Support",            url: "/resources/support/"     },
      { name: "Services",           url: "/resources/services/"    },
  ]},
  { name: "News",                   url: "/news/"                  }
];

// Menu icons
// Generated from https://base64.guru/converter/encode/image/webp
export const menuIcons = [];
